//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentRowToolbar",
  props: {
    download: {
      type: Boolean,
      default: true
    },
    edit: {
      type: Boolean,
      default: true
    },
    deletion: {
      type: Boolean,
      default: true
    },
    downloading: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    extracting: {
      type: Boolean,
      default: false
    },
    showExtract: {
      type: Boolean,
      default: false
    },
    deleting: {
      type: Boolean,
      default: false
    },
    move: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      shouldDelete: {
        type: Boolean,
        default: false
      }
    };
  },
  computed: {
    disableActions() {
      return this.editing;
    }
  },
  methods: {
    handleClick(eventName) {
      if (this.disableActions) return;
      this.$emit(eventName);
    }
  }
});